/**
 * Kaufberatungs-Werkzeuge im Turf-Hub
 *
 * Drei kleine Rechner, die dieselbe Substanz tragen wie die frueheren
 * Lesetexte -- nur beantwortet der Kunde die Frage mit seinen eigenen Zahlen,
 * statt sie sich aus einem Absatz herzuleiten.
 *
 * Kein einziger sichtbarer String steht in dieser Datei. Alle Texte kommen aus
 * `<script type="application/json" data-tw-i18n>` im Snippet, damit sie in den
 * Locale-Dateien liegen und uebersetzt werden.
 *
 * Geladen von `snippets/turf-werkzeug.liquid`, laeuft nur, wo ein Werkzeug steht.
 */
(function () {
  'use strict';

  function texte(wurzel) {
    var el = wurzel.querySelector('[data-tw-i18n]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function setzen(wurzel, name, wert) {
    var el = wurzel.querySelector('[data-tw="' + name + '"]');
    if (el) el.textContent = wert;
  }

  function zahl(v, ersatz) {
    var x = parseFloat(String(v).replace(',', '.'));
    return isFinite(x) && x > 0 ? x : ersatz;
  }

  /* --- A: Braucht dein Raum ueberhaupt Turf? --------------------------------
     Das Werkzeug darf "nein" sagen. Genau deshalb steht es an erster Stelle:
     Wer ehrlich abraet, dem glaubt man danach die Empfehlung. */
  function nutzung(wurzel) {
    var i18n = texte(wurzel);
    var chips = Array.prototype.slice.call(wurzel.querySelectorAll('[data-tw-opt]'));

    function zeichnen() {
      var gewaehlt = chips.filter(function (c) {
        return c.getAttribute('aria-pressed') === 'true';
      });
      var braucht = [], gummi = [], hatSchlitten = false, hatFlaeche = false;

      gewaehlt.forEach(function (c) {
        var name = c.textContent.trim();
        if (c.getAttribute('data-tw-turf') === '1') {
          braucht.push(name);
          if (c.getAttribute('data-tw-opt') === 'schlitten') hatSchlitten = true;
          else hatFlaeche = true;
        } else {
          gummi.push(name);
        }
      });

      var fall;
      if (!gewaehlt.length) fall = 'leer';
      else if (hatSchlitten) fall = 'schlitten';
      else if (hatFlaeche) fall = 'flaeche';
      else fall = 'kein';

      setzen(wurzel, 'urteil', i18n[fall] || '');
      setzen(wurzel, 'urteil_note', i18n[fall + '_note'] || '');
      setzen(wurzel, 'liste_turf', braucht.length ? braucht.join(' · ') : '—');
      setzen(wurzel, 'liste_gummi', gummi.length ? gummi.join(' · ') : '—');
      wurzel.setAttribute('data-tw-fall', fall);
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        zeichnen();
      });
    });

    zeichnen();
  }

  /* --- C: Passt die Bahn ins Haus? -----------------------------------------
     Im 25-mm-Fall nennt das Ergebnis die Menge, nicht nur das Produkt --
     "ECO CORE 15 in Bahngroesse" ist die Zeile, die heute auf keiner
     Bestellung steht, weil sie niemand sagt. */
  /* Werkzeuge auf derselben Seite reichen Zahlen direkt weiter, ohne Umweg
     ueber die URL. Seit 09.09.2026 steht der Unterlagen-Check hinter dem
     Massfinder: Der kennt die Bahnflaeche, jener braucht sie fuer die
     Plattenzahl. `flaecheZuletzt` deckt die Reihenfolge ab -- der Massfinder
     rechnet beim Initialisieren, da hat sich der Check noch nicht gemeldet. */
  var flaecheZuletzt = null;
  var flaecheHoerer = [];

  function flaecheMelden(m2) {
    flaecheZuletzt = m2;
    flaecheHoerer.forEach(function (fn) { fn(m2); });
  }

  function flaecheHoeren(fn) {
    flaecheHoerer.push(fn);
    if (flaecheZuletzt !== null) fn(flaecheZuletzt);
  }

  function unterlage(wurzel) {
    var i18n = texte(wurzel);
    var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-tw-boden]'));
    var box = wurzel.querySelector('[data-tw-box="mitbestellen"]');
    var feld = wurzel.querySelector('[data-tw-in="flaeche"]');
    var label = wurzel.querySelector('[data-tw="label"]');
    var flaecheStandard = zahl(box && box.getAttribute('data-tw-flaeche'), 20);
    var gewaehlt = null;

    /* `?sqm=` bleibt fuer den, der mit einer Flaeche im Link hereinkommt. Die
       Regel ist aber der Massfinder ueber diesem Werkzeug: Er meldet seine
       Flaeche, sobald sie sich aendert (siehe `flaecheHoeren`). Ohne beides
       bleibt das Feld mit der Vorbelegung stehen. */
    if (feld && typeof URLSearchParams === 'function' && window.location.search) {
      var qSqm = zahl(new URLSearchParams(window.location.search).get('sqm'), 0);
      if (qSqm > 0) feld.value = String(Math.round(qSqm * 10) / 10);
    }

    /* Platten sind 1 x 1 m, also ist die Stueckzahl die aufgerundete Flaeche.
       «Rund», weil der Zuschnitt am Rand die genaue Zahl bestimmt -- die steht
       in der Offerte, nicht hier. */
    function menge() {
      var f = zahl(feld && feld.value, flaecheStandard);
      return (i18n.mitbestellen || '')
        .replace('{{flaeche}}', String(Math.round(f * 10) / 10).replace('.', ','))
        .replace('{{platten}}', String(Math.ceil(f)));
    }

    /* `boden` ist null, solange nichts gewaehlt ist -- dann steht die Frage
       da, nicht eine Antwort ueber einen Raum, den wir nicht kennen. Das
       Label «Unter die Bahn kommt» haengt an derselben Bedingung, sonst
       ueberschreibt es eine leere Zeile. */
    function zeichnen(boden) {
      gewaehlt = boden;
      setzen(wurzel, 'aufbau', boden ? (i18n[boden + '_aufbau'] || '') : (i18n.leer || ''));
      setzen(wurzel, 'warum', boden ? (i18n[boden + '_warum'] || '') : (i18n.leer_note || ''));
      if (label) label.hidden = !boden;
      if (box) {
        var braucht = !!boden && (i18n.braucht || []).indexOf(boden) !== -1;
        box.hidden = !braucht;
        if (braucht) setzen(wurzel, 'mitbestellen', menge());
      }
      knoepfe.forEach(function (k) {
        k.setAttribute('aria-pressed', k.getAttribute('data-tw-boden') === boden ? 'true' : 'false');
      });
      wurzel.setAttribute('data-tw-fall', boden || 'leer');
    }

    knoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        zeichnen(k.getAttribute('data-tw-boden'));
      });
    });

    if (feld) {
      feld.addEventListener('input', function () { zeichnen(gewaehlt); });
      feld.addEventListener('change', function () { zeichnen(gewaehlt); });

      /* Das Mass oben fuehrt: Dreht der Kunde am Massfinder, gilt dessen
         Flaeche. Sein eigener Eintrag bleibt erhalten, solange er oben
         nichts aendert. */
      flaecheHoeren(function (m2) {
        feld.value = String(Math.round(m2 * 10) / 10);
        zeichnen(gewaehlt);
      });
    }

    var start = knoepfe.filter(function (k) {
      return k.getAttribute('aria-pressed') === 'true';
    })[0];
    zeichnen(start ? start.getAttribute('data-tw-boden') : null);
  }

  /* --- D: Was die Flaeche kostet -------------------------------------------
     Reine Division der Zahlen, die der Kunde selbst eintippt. Anlieferung und
     Verlegen bleiben bewusst leer und stehen als sichtbarer Posten daneben --
     eine erfundene Zahl waere hier schlimmer als eine fehlende.
     Flaeche und Anschaffung kommen mit `?sqm=&tot=` aus dem Planer mit; ohne
     diese Parameter gilt die Beispielbahn aus dem Block-Setting. */
  function rechnung(wurzel) {
    var i18n = texte(wurzel);
    var blatt = wurzel.querySelector('[data-tw-flaeche]');
    if (!blatt) return;

    var flaecheStandard = zahl(blatt.getAttribute('data-tw-flaeche'), 20);
    var preisStandard = zahl(blatt.getAttribute('data-tw-preis'), 0);
    var felder = {};
    Array.prototype.forEach.call(wurzel.querySelectorAll('[data-tw-in]'), function (el) {
      felder[el.getAttribute('data-tw-in')] = el;
    });

    if (typeof URLSearchParams === 'function' && window.location.search) {
      var q = new URLSearchParams(window.location.search);
      var qSqm = zahl(q.get('sqm'), 0);
      var qTot = zahl(q.get('tot'), 0);
      if (qSqm > 0 && qTot > 0) {
        if (felder.flaeche) felder.flaeche.value = String(Math.round(qSqm * 10) / 10);
        if (felder.preis) felder.preis.value = String(Math.round(qTot));
        setzen(wurzel, 'fussnote', i18n.hinweis_uebernommen || '');
      }
    }

    function chf(x) {
      return Math.round(x).toLocaleString('de-CH');
    }

    function zeichnen() {
      var flaeche = zahl(felder.flaeche && felder.flaeche.value, flaecheStandard);
      var preis = zahl(felder.preis && felder.preis.value, preisStandard);
      var jahre = zahl(felder.jahre && felder.jahre.value, 4);
      var miete = zahl(felder.miete && felder.miete.value, 0);
      var stunden = zahl(felder.stunden && felder.stunden.value, 0);
      var ertrag = zahl(felder.ertrag && felder.ertrag.value, 0);

      var proJahr = preis / jahre + flaeche * miete;
      var jahresstunden = stunden * 52;
      var proStunde = jahresstunden > 0 ? proJahr / jahresstunden : 0;

      setzen(wurzel, 'pro_jahr', chf(proJahr));
      setzen(wurzel, 'pro_stunde', jahresstunden > 0 ? chf(proStunde) : '—');

      if (jahresstunden > 0 && ertrag > 0 && proStunde > 0) {
        var faktor = ertrag / proStunde;
        var text = faktor >= 10 ? '10×+' : (Math.round(faktor * 10) / 10).toString().replace('.', ',') + '×';
        setzen(wurzel, 'deckung', text);
        setzen(wurzel, 'deckung_note', faktor >= 1
          ? (i18n.deckung_traegt || '').replace('{{faktor}}', text)
          : (i18n.deckung_knapp || ''));
      } else {
        setzen(wurzel, 'deckung', '—');
        setzen(wurzel, 'deckung_note', i18n.deckung_leer || '');
      }
    }

    Object.keys(felder).forEach(function (k) {
      felder[k].addEventListener('input', zeichnen);
      felder[k].addEventListener('change', zeichnen);
    });

    zeichnen();
  }

  /* --- B: Wie gross muss die Bahn sein? -------------------------------------
     Rechenregeln aus dem Konzept: 1-2 Spuren -> 2 m, 3-4 -> 4 m mit sofortiger
     Weiche auf zwei 2-m-Bahnen. Der Zweck setzt die Wunschlaenge, die freie
     Raumlaenge deckelt sie -- und sagt das offen, statt still zu kuerzen. */
  function massfinder(wurzel) {
    var i18n = texte(wurzel);
    var spuren = Array.prototype.slice.call(wurzel.querySelectorAll('[data-tw-spur]'));
    var zwecke = Array.prototype.slice.call(wurzel.querySelectorAll('[data-tw-zweck]'));
    var raumFeld = wurzel.querySelector('[data-tw-in="raum"]');
    var weiter = wurzel.querySelector('[data-tw="uebernehmen"]');
    var hinweis = wurzel.querySelector('[data-tw="hinweis"]');
    var BAND = { station: 8, alltag: 11, wettkampf: 16.5 };

    function gewaehlt(liste, attr) {
      var t = liste.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      return t ? t.getAttribute(attr) : null;
    }

    function komma(n) {
      return String(n).replace('.', ',');
    }

    function zeichnen() {
      var spur = parseInt(gewaehlt(spuren, 'data-tw-spur'), 10) || 2;
      var zweck = gewaehlt(zwecke, 'data-tw-zweck') || 'alltag';
      var breite = spur >= 3 ? 4 : 2;
      var wunsch = BAND[zweck];
      var raum = zahl(raumFeld && raumFeld.value, wunsch);
      /* Auf halbe Meter abrunden -- gefertigt wird jedes Mass, aber als
         Ausgangspunkt ist eine krumme Zahl hier nur Scheingenauigkeit. */
      var laenge = Math.max(2, Math.min(wunsch, Math.floor(raum * 2) / 2));
      var gedeckelt = laenge < wunsch;
      var flaeche = Math.round(breite * laenge * 10) / 10;

      /* 4 m Breite heisst zwei Bahnen a 2 m -- genau das raet der Hinweis, also
         zeigt und uebergibt das Werkzeug auch das, nicht eine 4-m-Rolle. */
      var bahnen = breite === 4 ? 2 : 1;
      var bahnBreite = breite === 4 ? 2 : breite;
      setzen(wurzel, 'masse', bahnen === 2
        ? (i18n.masse_zwei || '').replace('{{laenge}}', komma(laenge))
        : komma(breite) + ' m × ' + komma(laenge) + ' m');
      setzen(wurzel, 'flaeche', '· ' + komma(flaeche) + ' m²');
      setzen(wurzel, 'breite_warum', i18n['breite_' + (breite === 4 ? 4 : spur === 1 ? 1 : 2)] || '');

      var laengeText = i18n['laenge_' + zweck] || '';
      if (gedeckelt) {
        laengeText = (i18n.laenge_gedeckelt || '').replace('{{laenge}}', komma(laenge)) + ' ' + laengeText;
      }
      setzen(wurzel, 'laenge_warum', laengeText);
      setzen(wurzel, 'personen', i18n['personen_' + (spur >= 3 ? 4 : spur)] || '');

      var fall = null;
      if (breite === 4) fall = '4m';
      else if (flaeche < 10) fall = 'klein';
      else if (zweck === 'wettkampf' && gedeckelt) fall = 'kurz';

      if (hinweis) {
        hinweis.hidden = !fall;
        if (fall) {
          setzen(wurzel, 'hinweis_titel', i18n['hinweis_' + fall + '_titel'] || '');
          setzen(wurzel, 'hinweis_text',
            (i18n['hinweis_' + fall + '_text'] || '').replace('{{laenge}}', komma(laenge)));
        }
      }

      /* Die Masse reisen als Query mit -- der Planer liest l, wm und n beim
         Laden. Die Sprungmarke fuehrt direkt zur Ausfuehrungsliste: Ohne sie
         landet man am Seitenkopf, zwei Bildschirme ueber dem vorbelegten Mass. */
      if (weiter) {
        var basis = weiter.getAttribute('href').split('#')[0].split('?')[0];
        weiter.setAttribute('href', basis + '?l=' + laenge + '&wm=' + bahnBreite + '&n=' + bahnen + '#turf-konfigurieren');
      }

      /* Und dieselbe Flaeche geht an den Unterlagen-Check darunter -- er steht
         seit 09.09.2026 auf dieser Seite, damit die Plattenzahl mit dem
         gefundenen Mass rechnet statt mit der Beispielbahn. */
      flaecheMelden(flaeche);
    }

    function einfach(liste, attr) {
      liste.forEach(function (b) {
        b.addEventListener('click', function () {
          liste.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          zeichnen();
        });
      });
    }

    einfach(spuren, 'data-tw-spur');
    einfach(zwecke, 'data-tw-zweck');
    if (raumFeld) {
      raumFeld.addEventListener('input', zeichnen);
      raumFeld.addEventListener('change', zeichnen);
    }
    zeichnen();
  }

  var bauer = { nutzung: nutzung, unterlage: unterlage, rechnung: rechnung, massfinder: massfinder };

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ceq-tw]'), function (wurzel) {
      if (wurzel.hasAttribute('data-tw-bereit')) return;
      var fn = bauer[wurzel.getAttribute('data-ceq-tw')];
      if (!fn) return;
      wurzel.setAttribute('data-tw-bereit', '1');
      fn(wurzel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Der Theme-Editor haengt Bloecke nach, ohne die Seite neu zu laden. */
  document.addEventListener('shopify:section:load', start);
})();
